try {
  (function () {
    if (!document.documentElement.lang.startsWith("es")) return;

    const BUTTON_CLASS = "docapp-coupon-input--button-text";
    const CONTAINER_CLASS = "docapp-cart-with-coupon-summary";
    const CART_DRAWER = document.querySelector(
      "cart-drawer, #CartDrawer, .cart-drawer"
    );

    if (!CART_DRAWER) return;

    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    function updateButtonText(button) {
      if (button && button.textContent !== "Aplicar") {
        button.textContent = "Aplicar";
      }
    }

    function findAndUpdateButton(container) {
      const button = container.querySelector("." + BUTTON_CLASS);
      if (button) {
        updateButtonText(button);
        return true;
      }
      return false;
    }

    const containerObserver = new MutationObserver(
      debounce((mutations) => {
        const container = CART_DRAWER.querySelector("." + CONTAINER_CLASS);
        if (!container) return;

        if (findAndUpdateButton(container)) {
          return;
        }

        const buttonObserver = new MutationObserver(
          debounce((mutations) => {
            const relevantMutation = mutations.some(
              (mutation) =>
                Array.from(mutation.addedNodes).some(
                  (node) =>
                    node.classList && node.classList.contains(BUTTON_CLASS)
                ) ||
                (mutation.target.classList &&
                  mutation.target.classList.contains(BUTTON_CLASS))
            );

            if (relevantMutation) {
              findAndUpdateButton(container);
            }
          }, 100)
        );

        buttonObserver.observe(container, {
          childList: true,
          subtree: true,
        });
      }, 100)
    );

    const observerTarget = CART_DRAWER.shadowRoot || CART_DRAWER;

    containerObserver.observe(observerTarget, {
      childList: true,
      subtree: true,
    });

    window.addEventListener(
      "beforeunload",
      () => {
        containerObserver.disconnect();
      },
      { once: true }
    );
  })();
} catch (e) {
  console.error("Error in cart script:", e);
}
